import styled from 'styled-components';

const Container = styled.div `
    background:#FFFFFFD7;
    width: 95%;
    max-width: 95vw;
    margin-top: 100px !important;
    height: 100vh;
    overflow-y: auto;
    margin: auto;
    display: flex;
    flex-direction: column;
    position: relative;
    z-index: 100;
    -webkit-box-shadow: 6px 7px 26px -6px rgba(0,0,0,0.62);
    -moz-box-shadow: 6px 7px 26px -6px rgba(0,0,0,0.62);
    box-shadow: 6px 7px 26px -6px rgba(0,0,0,0.62);


    
/* Móviles grandes */
/*@media only screen and (min-width: 481px) and (max-width: 768px) {

}*/


/* Tabletas (769px - 1024px) */
@media(min-width: 769px) and (max-width: 1299px) {

}

/* Escritorio pequeño (1025px - 1280px) */
@media(min-width: 1300px) and (max-width: 2300px)  {

}
    
`   
;

export default Container;